import React from "react";

export default function Underconstruct() {
  return (
    <div className="underconstruct-back">
      <h1 style={{ color: "black" }}>Building...</h1>
    </div>
  );
}
